import { Component } from '@angular/core';

@Component({
  selector: 'app-agriculture',
  templateUrl: './agriculture.component.html',
  styleUrl: './agriculture.component.scss'
})
export class AgricultureComponent {

}
